import { DataBean } from "../DataBean";

export class EmployeeIncapacity extends DataBean {
  public async getEmployeeIncapacities(
    accountID: number | null,
    year: number,
    month: number,
    type: number | null
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "java.util.List_getEmployeeIncapacities_Number_Number_Number_Number_Number",
      [accountID, year, month, null, type]
    );
  }
  public async getEmployeeIncapacitiesforpaginator(
    accountID: number | null,
    year: number,
    month: number,
    state: any,
    type: number | null,
    page: any,
    recordsPerPage: any
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "com.advantage.shared.Report_getEmployeeIncapacities_Number_Number_Number_Number_Number_Number_Number",
      [accountID, year, month, state, type, page, recordsPerPage]
    );
  }

  public async getIncapacityTypeConstants(arg: number | null): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "java.util.List_getIncapacityTypeConstants_Number",
      [arg]
    );
  }

  public async getLiquidateMonthConstants(arg: number | null): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "java.util.List_getLiquidateMonthConstants_Number",
      [arg]
    );
  }

  public async deleteEmployeeIncapacity(idIncapacity: number): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "Integer_deleteEmployeeIncapacity_Number",
      [idIncapacity]
    );
  }

  public async updateMonthAppliedIncapacityDistribution(idIncapacity: number, year: number, initialPaymentMonth: number): Promise<any> {
    return this.getCustomService("QuickDataERPCore", "boolean_updateMonthAppliedIncapacityDistribution_Number_Number_Number", [idIncapacity, year, initialPaymentMonth]);
  }

  public async updatetEmployeeIncapacitiesDistribution(accountID: number, year: number, Month: number): Promise<any> {
    return this.getCustomService("QuickDataERPCore", "boolean_updatetEmployeeIncapacitiesDistribution_Number_Number_Number", [accountID, year, Month]);
  }

  public async approveEmployeeIncapacity(idIncapacity: number, idEmployee: number): Promise<any> {
    return this.getCustomService("QuickDataERPCore", "employees.EmployeeIncapacity_approveEmployeeIncapacity_Number_Number", [idIncapacity, idEmployee]);
  }

  public async fileEmployeeIncapacity(idIncapacity: number, filedNumber: number, idEmployee: number): Promise<any> {
    return this.getCustomService("QuickDataERPCore", "employees.EmployeeIncapacity_fileEmployeeIncapacity_Number_Number_Number", [idIncapacity, filedNumber, idEmployee]);
  }

  public async rejectEmployeeIncapacity(idIncapacity: number, observations: string, idEmployee: number): Promise<any> {
    return this.getCustomService("QuickDataERPCore", "employees.EmployeeIncapacity_rejectEmployeeIncapacity_Number_String_Number", [idIncapacity, observations, idEmployee]);
  }

  public async getElectronicPayrollIncapacitiesYears(args: number): Promise<any> {
    return this.getCustomService("QuickDataERPCore", "java.util.List_getElectronicPayrollIncapacitiesYears_Number", [args]);
  }

  public async getElectronicPayrollIncapacitiesMonths(year: number): Promise<any> {
    return this.getCustomService("QuickDataERPCore", "java.util.List_getElectronicPayrollIncapacitiesMonths_Number", [year]);
  }

  public async updateEmployeeIncapacity(bean: number): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "employees.EmployeeIncapacity_updateEmployeeIncapacity_employees.EmployeeIncapacity",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "employees.EmployeeIncapacity",
        },
      ]
    );
  }
}
